import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { environment } from "@environments/environment";

@Injectable({ providedIn: "root" })
export class DatabseBackupService {
  headers = new HttpHeaders().set("Content-Type", "application/json");
  constructor(private http: HttpClient) {}
  // Get All
  getAll() {
    return this.http.get<String[]>(`${environment.apiUrl}/db-backup/list`);
  }

  delete(fileName: string) {
    return this.http.delete<Element>(
      `${environment.apiUrl}/db-backup/${fileName}`,
    );
  }

  download(fileName: string) {
    return this.http.get(
      `${environment.apiUrl}/db-backup/download/${fileName}`,
      { responseType: "blob" },
    );
  }

  create() {
    return this.http.post<String>(`${environment.apiUrl}/db-backup/backup`, {});
  }
}
